import PlanejamentoAcaoFormComportamento from '../../../produto/spa/planejamento-acao/form/PlanejamentoAcaoFormComportamento';

export default PlanejamentoAcaoFormComportamento;
